module.exports = __webpack_public_path__ + "static/media/chevron-right.f2b187b8.svg";